export default __webpack_public_path__ + "static/media/q12_step3.afb988b2.png";